import React, { Component } from "react";
import { Switch, Route, Router } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import { Spin } from "antd";
import Login from "./guest/login/login-route";
import PrivateRoute from "../components/common/private-route";
import { browserHistory } from "../common/utils/history";
import { store, persistor } from "../common/store/custom-store";
import ScrollToTop from "../components/common/scroll-top";
import { updateAuthData } from "../common/actions/actions-auth";
import { emitter } from "../common/utils/emitter";
import { MainLayout } from "./authen/main-layout";
import { ContractTable } from "./authen/contract/contract-table";
import { UserTable } from "./authen/user/user-table";
import { UserAccountTable } from "./authen/user-account/user-account-table";
import { UserPermissionTable } from "./authen/user-permission/user-permission-table";
import { VehicleTable } from "./authen/vehicle/vehicle-table";
import { JourneyDiary } from "./authen/journey-diary/journey-detail/journey-diary";
import JourneyTable from "./authen/journey-diary/journey-table";
import { DriverList } from "./authen/driver/driver-list/driver-list";
import { NotificationTable } from "./authen/customer/notification/notification-table";
import CustomerPaymentRequest from "./authen/customer/payment-request/customer-payment-request";
import { CustomerReview } from "./authen/customer/review/customer-review";
import { SummaryReport } from "./authen/summary-report/summary-report";
import { ReviewTable } from "./authen/review/review-table";
import "../assets/scss/style.scss";

export default class Root extends Component {
  state = {
    loading: false,
    spinning: false,
  };

  componentDidMount() {
    emitter.addListener("LOADED", (value) => {
      this.setState({ loading: value });
    });
    emitter.addListener("FETCH_LOADING", (spinning) => {
      this.setState({ spinning });
    });
  }

  onBeforeLift() {
    this.refreshAuth();
  }

  refreshAuth = async () => {
    const { auth } = store.getState();

    if (auth) {
      this.setState({ loading: true });
      store.dispatch(updateAuthData(auth));
    }
  };

  componentWillUnmount() {
    emitter.removeAllListeners();
  }

  render() {
    return (
      <Provider store={store}>
        <PersistGate
          onBeforeLift={() => this.onBeforeLift()}
          loading={null}
          persistor={persistor}
        >
          <Spin spinning={this.state.spinning} tip="Loading...">
            {!this.state.loading && (
              <Router history={browserHistory}>
                <ScrollToTop>
                  <Switch>
                    <Route path="/login" component={Login} />
                    <MainLayout>
                      <PrivateRoute exact path="/" component={ContractTable} />
                      <PrivateRoute path="/customer" component={UserTable} />
                      <PrivateRoute
                        path="/user-account"
                        component={UserAccountTable}
                      />
                      <PrivateRoute
                        path="/user-permission"
                        component={UserPermissionTable}
                      />
                      <PrivateRoute path="/vehicle" component={VehicleTable} />
                      <PrivateRoute
                        path="/journey-diary"
                        component={JourneyTable}
                      />
                      <PrivateRoute path="/driver" component={DriverList} />
                      <PrivateRoute
                        path="/notification"
                        component={NotificationTable}
                      />
                      <PrivateRoute
                        path="/customer-pr"
                        component={CustomerPaymentRequest}
                      />
                      <PrivateRoute
                        path="/customer-review"
                        component={CustomerReview}
                      />
                      <PrivateRoute
                        path="/summary-report"
                        component={SummaryReport}
                      />
                      <PrivateRoute path="/review" component={ReviewTable} />
                    </MainLayout>
                  </Switch>
                </ScrollToTop>
              </Router>
            )}
          </Spin>
        </PersistGate>
      </Provider>
    );
  }
}
